export default {
  'pt': {
    'failedToSend': 'Falha ao enviar a mensagem.',
    'failedToLoadThreadSummary': 'Falha ao carregar o resumo da conversa.',
    'userWaitingAttendance': 'Chatbot {chatbotIdentity} encaminhou a conversa para atendimento',
    'closedAttendantMsg': 'Atendente {agentIdentity} encerrou o atendimento',
    'closedClientMsg': 'Cliente encerrou o atendimento',
    'showMore': 'Ver mais',
    'aspectRatio': 'Proporção da tela',
    'supportedFormats': 'Formatos suportados: JPEG,JPG,PNG,GIF',
    'fileUrl': 'URL do arquivo',
    'title': 'Título',
    'titleThreadSummary': 'Resumo da conversa',
    'imageUri': 'Uri da imagem',
    'text': 'Texto',
    'videoUri': 'Uri do vídeo',
    'cancel': 'Cancelar',
    'setPayload': 'Definir carga',
    'addButton': 'Adicionar Botão',
    'link': 'Link',
    'description': 'Descrição',
    'uri': 'Uri',
    'postbackMimetype': 'Mime type do postback',
    'postbackValue': 'Valor de postback',
    'addOption': 'Adicionar Opção',
    'notEnoughOptions': 'Requer pelo menos uma opção',
    'pageUrl': 'URL da página',
    'introduction': 'Mensagem de texto de introdução',
    'latitude': 'Latitude',
    'longitude': 'Longitude',
    'RequestLocationButtonLabel': 'Enviar Localização',
    'unsupportedContent': 'Conteúdo não suportado',
    'messageTemplate': 'Modelo de mensagem: ',
    'phoneLabel': 'Telefone',
    'mailLabel': 'E-mail',
    'addressLabel': 'Endereço',
    'failedToLoad': 'Falha ao carregar mensagem',
    'reactionText': 'Reação',
    'removedReactionText': 'Reação removida',
    'replyText': 'Resposta',
    'startCallMsg': 'Início da chamada de {callType} {callTime}',
    'endCallMsg': 'Fim da chamada de {callType} {callTime}',
    'videoMsg': 'vídeo',
    'audioMsg': 'áudio',
    'videoCallMsg': 'Chamada de vídeo',
    'voiceCallMsg': 'Ligação',
    'successStatusMsg': 'Finalizada',
    'failedStatusMsg': 'Falha',
    'cancelStatusMsg': 'Cancelada',
    'notAnsweredStatusMsg': 'Não atendida',
    'preparingRecordingMsg': 'Preparando gravação',
    'loadRecordingMsg': 'Carregar gravação',
    'downloadRecordingLabel': 'Baixar gravação',
    'callsPermissionRequestBodyTitle': 'Atendente {username} quer ligar para você.',
    'callsPermissionRequestBodyText': 'Ao escolher "Sim", você aceita receber uma ligação.',
    'callsPermissionRequestLeftActionLabel': 'Não',
    'callsPermissionRequestRightActionLabel': 'Sim',
    'callsPermissionReplyAcceptText': 'O cliente aceitou receber ligações ativas.',
    'callsPermissionReplyRejectText': 'O cliente rejeitou receber ligações ativas.',
    'transcribeRecordingLabel': 'Ver transcrição',
    'audioTranscription': {
      'action': 'Transcrever áudio',
      'loading': 'Preparando transcrição...',
      'fullTranscription': 'Transcrição completa',
      'title': 'Transcrição de áudio',
      'readMore': 'Ler mais',
      'readLess': 'Ler menos'
    },
    'labelAudio': 'Áudio',
    'location': 'Localização'
  },
  'en': {
    'failedToSend': 'Failed to send message.',
    'failedToLoadThreadSummary': 'Falha ao carregar o resumo da conversa.',
    'userWaitingAttendance': 'Chatbot {chatbotIdentity} forwarded the conversation for attendance',
    'closedAttendantMsg': 'Attendant {agentIdentity} closed the attendance',
    'closedClientMsg': 'Client closed the attendance',
    'showMore': 'More',
    'aspectRatio': 'Aspect Ratio',
    'supportedFormats': 'Supported formats: JPEG,JPG,PNG,GIF',
    'fileUrl': 'File URL',
    'title': 'Title',
    'titleThreadSummary': 'Resumo da conversa',
    'imageUri': 'Image Uri',
    'text': 'Text',
    'videoUri': 'Video Uri',
    'cancel': 'Cancel',
    'setPayload': 'Set Payload',
    'addButton': 'Add Button',
    'link': 'Link',
    'description': 'Description',
    'uri': 'Uri',
    'postbackMimetype': 'Postback mime type',
    'postbackValue': 'Postback value',
    'addOption': 'Add option',
    'notEnoughOptions': 'Requires at least 1 option',
    'pageUrl': 'Page URL',
    'introduction': 'Introduction text message',
    'latitude': 'Latitude',
    'longitude': 'Longitude',
    'RequestLocationButtonLabel': 'Send Location',
    'unsupportedContent': 'Unsupported Content',
    'messageTemplate': 'Message template: ',
    'phoneLabel': 'Phone',
    'mailLabel': 'E-mail',
    'addressLabel': 'Address',
    'failedToLoad': 'Failed to load message',
    'reactionText': 'Reaction',
    'removedReactionText': 'Reaction removed',
    'replyText': 'Response',
    'startCallMsg': 'Start of {callType} call {callTime}',
    'endCallMsg': 'End of {callType} call {callTime}',
    'videoMsg': 'video',
    'audioMsg': 'phone',
    'videoCallMsg': 'Video call',
    'voiceCallMsg': 'Phone call',
    'successStatusMsg': 'Ended',
    'failedStatusMsg': 'Failed',
    'cancelStatusMsg': 'Canceled',
    'notAnsweredStatusMsg': 'Not answered',
    'preparingRecordingMsg': 'Preparing the recording',
    'loadRecordingMsg': 'Load recording',
    'downloadRecordingLabel': 'Download recording',
    'callsPermissionRequestBodyTitle': 'Agent {username} wants to call you.',
    'callsPermissionRequestBodyText': 'By choosing "Yes", you agree to receive a call.',
    'callsPermissionRequestLeftActionLabel': 'No',
    'callsPermissionRequestRightActionLabel': 'Yes',
    'callsPermissionReplyAcceptText': 'The customer has accepted to receive outbound calls.',
    'callsPermissionReplyRejectText': 'The customer has rejected to receive outbound calls.',
    'transcribeRecordingLabel': 'View transcription',
    'audioTranscription': {
      'action': 'Transcribe audio',
      'loading': 'Preparing transcription...',
      'fullTranscription': 'Full transcription',
      'title': 'Audio transcription',
      'readMore': 'Read more',
      'readLess': 'Read less'
    },
    'labelAudio': 'Audio',
    'location': 'Location'
  },
  'es': {
    'failedToSend': 'No se pudo enviar el mensaje.',
    'failedToLoadThreadSummary': 'Falha ao carregar o resumo da conversa.',
    'userWaitingAttendance': 'Chatbot {chatbotIdentity} reenvió la conversación a la asistencia',
    'closedAttendantMsg': 'Agente {agentIdentity} terminó el servicio',
    'closedClientMsg': 'Servicio finalizado por el cliente',
    'showMore': 'Ver más',
    'aspectRatio': 'Proporción de pantalla',
    'supportedFormats': 'Formatos compatibles: JPEG, JPG, PNG, GIF',
    'fileUrl': 'URL de archivo',
    'title': 'Título',
    'titleThreadSummary': 'Resumo da conversa',
    'imageUri': 'Uri de Imagen',
    'text': 'Texto',
    'videoUri': 'Uri de Video',
    'cancel': 'Cancelar',
    'setPayload': 'Establecer carga',
    'addButton': 'Agregar botón',
    'link': 'Link',
    'description': 'Descripción',
    'uri': 'Uri',
    'postbackMimetype': 'Postback tipo Mime',
    'postbackValue': 'Valor de postback',
    'addOption': 'Agregar opción',
    'notEnoughOptions': 'Requiere al menos una opción',
    'pageUrl': 'URL de la página',
    'introduction': 'Mensaje de texto de introducción',
    'latitude': 'Latitud',
    'longitude': 'Longitud',
    'RequestLocationButtonLabel': 'Enviar ubicación',
    'unsupportedContent': 'Contenido no compatible',
    'messageTemplate': 'Plantilla de mensaje: ',
    'phoneLabel': 'Teléfono',
    'mailLabel': 'Correo electrónico',
    'addressLabel': 'Dirección',
    'failedToLoad': 'Error al cargar el mensaje',
    'reactionText': 'Reacción',
    'removedReactionText': 'Reacción eliminada',
    'replyText': 'Respuesta',
    'startCallMsg': 'Inicio de {callType} {callTime}',
    'endCallMsg': 'Fin de la {callType} {callTime}',
    'videoMsg': 'videollamada',
    'audioMsg': 'llamada',
    'videoCallMsg': 'Videollamada',
    'voiceCallMsg': 'Llamada',
    'successStatusMsg': 'Finalizada',
    'failedStatusMsg': 'Fallida',
    'cancelStatusMsg': 'Cancelada',
    'notAnsweredStatusMsg': 'No atendida',
    'preparingRecordingMsg': 'Grabación en curso',
    'loadRecordingMsg': 'Cargar grabación',
    'downloadRecordingLabel': 'Descargar grabación',
    'callsPermissionRequestBodyTitle': 'Agente {username} quiere llamarte.',
    'callsPermissionRequestBodyText': 'Al elegir "Sí", aceptas recibir una llamada.',
    'callsPermissionRequestLeftActionLabel': 'No',
    'callsPermissionRequestRightActionLabel': 'Sí',
    'callsPermissionReplyAcceptText': 'El cliente ha aceptado recibir llamadas salientes.',
    'callsPermissionReplyRejectText': 'El cliente ha rechazado recibir llamadas salientes.',
    'transcribeRecordingLabel': 'Ver transcripción',
    'audioTranscription': {
      'action': 'Transcribir audio',
      'loading': 'Preparando transcripción...',
      'fullTranscription': 'Transcripción completa',
      'title': 'Transcripción de audio',
      'readMore': 'Leer más',
      'readLess': 'Leer menos'
    },
    'labelAudio': 'Audio',
    'location': 'Ubicación'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/blip-cards.js